"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_loader_spinner_1 = require("react-loader-spinner");
const spinner_module_css_1 = __importDefault(require("./spinner.module.css"));
const Spinner = () => ((0, jsx_runtime_1.jsx)("div", { className: spinner_module_css_1.default.inner, children: (0, jsx_runtime_1.jsx)(react_loader_spinner_1.RotatingLines, { visible: true, strokeWidth: '3', strokeColor: '#007AFF', width: '50' }) }));
exports.Spinner = Spinner;
